import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zqlcpwmvoflnkbowkksh.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpxbGNwd212b2Zsbmtib3dra3NoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY4NTQ1OTUsImV4cCI6MjA4MjQzMDU5NX0.m4SmO2v9pmJD63qjRzSkdCFOxRSbi0IR4QAVjaTNdoQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
